const states = {
  goodsList: [],  // 有效商品列表
};
export default states;
